import React, { useRef } from "react";
import { Dropdown, Form } from "react-bootstrap";
import "./TaskAssignMembers.scss";
import PropTypes from "prop-types";

const MemberSuggestionsInput = ({
  role,
  inputValue,
  showSuggestions,
  disablePill,
  errorMessage,
  showUserMembers,
  onChangeMemberInput,
  onKeyDownAddMembers,
  onClickMemberSuggestion,
  handleLostFocus,
  handleOnFocus,
  usersFromProjectAndDepartment
}) => {
  const node = useRef();

  return (
      <div className="dropdown-main-top-level" ref={node}>
        <Dropdown className="dropdown-main" show={showSuggestions}>
          <Dropdown.Toggle
            tabIndex="0"
            id="dropdown-toggle"
            className={`pill-wapper dropdown-button assignMembersWrapper ${
              disablePill
                ? "dropdown-members dropdown-button-disabled"
                : "dropdown-members"
            } dropdown-input`}
            as="div"
          >
            {showUserMembers(role)}
            <input
              type="text"
              value={inputValue}
              onChange={e => onChangeMemberInput(e, role)}
              onKeyDown={e => {
                onKeyDownAddMembers(e, role);
                e.key === "Enter" && e.preventDefault();
              }}
              onBlur={e => handleLostFocus(role, e)}
              onClick={e => handleOnFocus(role, e)}
              placeholder="Enter new member"
              disabled={disablePill}
            />
          </Dropdown.Toggle>

          <Dropdown.Menu className="dropdown-main-menu" as="div">
            {usersFromProjectAndDepartment(role)}
          </Dropdown.Menu>
        </Dropdown>

        {errorMessage && (
          <Form.Label>
            <div className="error-message-assign">{errorMessage}</div>
          </Form.Label>
        )}
      </div>
  );
};

export default MemberSuggestionsInput;

MemberSuggestionsInput.propTypes = {
    role: PropTypes.oneOf(['owner', 'editor', 'viewer', 'approver']).isRequired,
    inputValue: PropTypes.string.isRequired,
    showSuggestions: PropTypes.bool.isRequired,
    disablePill: PropTypes.bool,
    errorMessage: PropTypes.string,
    showUserMembers: PropTypes.func.isRequired,
    onChangeMemberInput: PropTypes.func.isRequired,
    onKeyDownAddMembers: PropTypes.func.isRequired,
    onClickMemberSuggestion: PropTypes.func.isRequired,
    handleLostFocus: PropTypes.func.isRequired,
    handleOnFocus: PropTypes.func.isRequired,
    usersFromProjectAndDepartment: PropTypes.func.isRequired
  };
  
  MemberSuggestionsInput.defaultProps = {
    disablePill: false,
    errorMessage: ''
  };